import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

export enum Status {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}
export interface StageStatus {
  name: string;
  status: Status;
}

@Component({
  selector: 'sms-progress-tracker',
  imports: [CommonModule, MatIcon],
  templateUrl: './progress-tracker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-tracker.component.scss',
})
export class ProgressTrackerComponent {
  @Input({ required: true }) stages: StageStatus[] = [];

  private cssClasses: Map<Status, string> = new Map([
    [Status.NotStarted, 'tracker-not-started-color'],
    [Status.InProgress, 'tracker-in-progress-color'],
    [Status.Completed, 'tracker-completed-color'],
    [Status.Failed, 'tracker-failed-color'],
  ]);

  getClassForStatus(status: Status): string {
    return this.cssClasses.get(status) ?? '';
  }
}
